/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Button, Dialog, Tag } from '@coursera/cds-core';

import _t from 'i18n!nls/enterprise-learning-path-description-page';

const styles = {
  container: css`
    display: flex;
    flex-wrap: wrap;
    gap: var(--cds-spacing-100);
  `,
  section: css`
    margin-bottom: var(--cds-spacing-300);

    &:last-of-type {
      margin-bottom: 0;
    }
  `,
  heading: css`
    margin-bottom: var(--cds-spacing-200);
  `,
  tagOverrides: css`
    padding: var(--cds-spacing-50) var(--cds-spacing-150);
    border-radius: var(--cds-border-radius-max);
  `,
};

type Props = {
  open: boolean;
  onClose: () => void;
  tools: string[];
};

const ToolsDialog = ({ open, onClose, tools }: Props) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <Dialog.HeadingGroup>{_t("Tools you'll use")}</Dialog.HeadingGroup>
      <Dialog.Content>
        <div css={styles.section}>
          <div css={styles.container}>
            {tools.map((tool) => (
              <Tag key={`dialog-tool-${tool}`} css={styles.tagOverrides}>
                {tool}
              </Tag>
            ))}
          </div>
        </div>
      </Dialog.Content>
      <Dialog.Actions>
        <Button variant="primary" size="medium" onClick={onClose}>
          {_t('OK')}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

export default ToolsDialog;
